<template>
  <div class="finishing-options-page">
    <div class="container">
      <h1 class="page-title">Die Casting Surface Finishes</h1>

      <div class="table-wrapper">
        <table class="finishing-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Finishing</th>
              <th>Description</th>
              <th>Application</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in finishingList" :key="index">
              <td>
                <img :src="item.image" alt="" class="process-img" />
              </td>
              <td class="process-link">{{ item.name }}</td>
              <td>
                <div>
                  <span class="process-link">Description: </span>
                  {{ item.desc }}
                </div>
                <br v-if="item.roughness" />
                <span v-if="item.roughness" class="process-link">Surface Roughness: </span>
                <span v-if="item.roughness">{{ item.roughness }}</span>
              </td>
              <td>{{ item.application }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="note-bar">
        <p class="note-text">
          *For Surface Finishes not listed here, <span class="contact-link" @click="$router.push('/contact')">please contact us directly.</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DieCasting_FinishingOptions',
  data() {
    return {
   finishingList: [
  {
    name: 'As Cast',
    image: require('@/assets/ma/die/1.png'),
    desc: 'Provides a basic, functional finish for die casting products with relatively smooth surfaces and minor tool marks, suitable for non-cosmetic applications.',
    roughness: 'Typically Ra 3.2-12.5 µm, depending on casting process and mold condition.',
    application: 'Industrial housings, internal structural components, mechanical brackets, and functional die cast parts where appearance is not critical.'
  },
  {
    name: 'Anodizing',
   image: require('@/assets/ma/die/2.png'),
    desc: 'Improves corrosion and wear resistance of aluminum cast parts, while allowing for color options that enhance both durability and appearance.',
    roughness: 'Typically Ra 0.8-3.2 µm depending on the original cast surface and anodizing type.',
    application: 'Consumer electronics, appliance housings, outdoor equipment, decorative aluminum die cast parts.'
  },
  {
    name: 'Chromate Passivation',
   image: require('@/assets/ma/die/3.png'),
    desc: 'Commonly used for aluminum and zinc die casted parts, chromate passivation improves corrosion resistance and prepares the surface for painting or other coatings.',
    roughness: 'Minimal change to original surface roughness; typically maintains Ra 1.6-6.3 µm.',
    application: 'Automotive components, electronic enclosures, parts needing corrosion resistance before painting.'
  },
  {
    name: 'Painting',
  image: require('@/assets/ma/die/4.png'),
    desc: 'Adds color and improves appearance while offering additional protection against corrosion and wear. Often used for branding or to meet specific design requirements.',
    roughness: 'Depends on paint type and application method; typically smooth or lightly textured finish.',
    application: 'Consumer products, automotive trim, appliance components, custom color and branding parts.'
  },
  {
    name: 'Sand Blasting',
  image: require('@/assets/ma/die/5.png'),
    desc: 'Abrasive blasting that removes surface impurities and gives a uniform, matte texture. It also improves paint or coating adhesion.',
    roughness: 'Typically Ra 1.6-6.3 µm depending on abrasive media and blasting pressure.',
    application: 'Surface pre-treatment for coating, decorative matte finish, parts requiring improved paint or coating adhesion.'
  }
]
    }
  }
}
</script>

<style scoped>
.finishing-options-page {
  padding: 40px 20px;
  background-color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.container {
  /* ✨ 核心：限制最大宽度并允许自适应缩小 */
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.page-title {
  /* ✨ 响应式标题：手机上 24px，电脑上 32px */
  font-size: clamp(24px, 4vw, 32px);
  color: #333333;
  text-align: center;
  margin: 0 0 30px;
  font-weight: 600;
}

/* ✨ 核心：表格的外层包裹器 */
.table-wrapper {
  width: 100%;
  margin-bottom: 30px;
  overflow-x: auto; /* 允许横向滑动 */
  -webkit-overflow-scrolling: touch; /* 让 iOS 设备上滑动更顺滑 */
  /* 给表格加个细微边框和阴影，滑动时更有边界感 */
  border: 1px solid #f0ecec; 
  border-radius: 8px;
}

.finishing-table {
  width: 100%;
  /* ✨ 核心：给表格设定一个最小宽度，当屏幕小于800px时，表格不会继续被挤压，而是出现横向滚动条 */
  min-width: 800px; 
  border-collapse: collapse;
  background-color: #ffffff;
}

.finishing-table thead tr {
  background-color: #f0f4f5;
}

.finishing-table th,
.finishing-table td {
  padding: 18px 15px;
  text-align: left;
  color: #666666;
  font-size: 16px;
  line-height: 1.6;
}

.finishing-table th {
  font-weight: 600;
  color: #333333;
  /* 表头文字左对齐更利于阅读长表格 */
  text-align: left; 
}

.finishing-table tbody tr {
  border-top: 1px solid #f0ecec;
}

/* 去除首行边框，因为外层 wrapper 已经有了 */
.finishing-table tbody tr:first-child {
  border-top: none; 
}

/* 调整列宽分配，使其更合理 */
.finishing-table td:nth-child(1),
.finishing-table th:nth-child(1) {
  width: 100px;
  padding: 12px;
}

.finishing-table td:nth-child(2),
.finishing-table th:nth-child(2) {
  width: 160px;
  font-weight: 600;
}

.finishing-table td:nth-child(3),
.finishing-table th:nth-child(3) {
  width: 50%;
}

.finishing-table td:nth-child(4),
.finishing-table th:nth-child(4) {
  width: 25%;
}

.process-img {
  width: 80px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
}

.process-link {
  font-weight: 500;
}

.note-bar{
  width: 100%;
}

.note-text {
  margin: 0;
  font-size: 15px;
  color: #666666;
  line-height: 1.6;
}

.contact-link {
  color: #16bc9c;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
}

.contact-link:hover {
  text-decoration: underline;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .finishing-options-page {
    padding: 30px 15px;
  }
  
  .finishing-table th,
  .finishing-table td {
    padding: 12px 10px;
    font-size: 14px; /* 移动端字号稍微调小一点 */
  }
  
  .process-img {
    width: 60px;
    height: 45px;
  }
  
  .note-text {
    font-size: 14px;
  }
}
</style>